import errorManager from '@/rollbar.js';

const setFromHour = (target, val) => {
  let today = new Date();
  let parsedValDay = val.split('/');
  if (new Date(parsedValDay[2], parsedValDay[1] - 1, parsedValDay[0]) > today) {
    target.val('00:00');
  } else {
    let defaultHour = target.val() === '00:00' ? today.getHours() + ':' + today.getMinutes() : target.data('default-hour');
    if (!val || val === '') defaultHour = null;
    target.val(defaultHour);
  }
};

const setToHour = (target, val) => {
  let defaultHour = target.val() || target.data('default-hour');
  if (!val || val === '') defaultHour = null;
  target.val(defaultHour);
};

const consistencyCheck = (target_from, val_from, target_to, val_to) => {
  target_from.popover('destroy');

  let dateFrom = val_from.split('/');
  let dateFromParsed = new Date(dateFrom[2], dateFrom[1] - 1, dateFrom[0]);
  let dateTo = val_to.split('/');
  let dateToParsed = new Date(dateTo[2], dateTo[1] - 1, dateTo[0]);
  if (dateFromParsed > dateToParsed) {
    let options = target_from.data();
    options['title'] = 'ATTENZIONE';
    options['content'] =
      'La terapia inizia il ' +
      val_from +
      ' e finisce il ' +
      val_to +
      '<button type="button" class="close close-popover" style="position: absolute; right: 13px; top: 8px;">&times;</button>';
    options['trigger'] = 'focus';
    options['html'] = true;
    target_from.popover(options);
    target_from.popover('show');
  }

  setTimeout(() => {
    $('.close-popover').on('click', () => {
      target_from.popover('hide');
    });
  }, 0);
};

const setPopover = (popoverInput, date) => {
  popoverInput.popover('destroy');
  if (!date || date === '') return;

  let options = popoverInput.data();
  options['title'] = 'ATTENZIONE';
  options['content'] =
    'La terapia cesserà alle ore ' +
    popoverInput.val() +
    ' del giorno ' +
    date +
    '<button type="button" class="close close-popover" style="position: absolute; right: 13px; top: 8px;">&times;</button>';
  options['trigger'] = 'focus';
  options['html'] = true;
  popoverInput.popover(options);
  popoverInput.popover('show');

  setTimeout(() => {
    $('.close-popover').on('click', () => {
      popoverInput.popover('hide');
    });
  }, 0);
};

const setListener = (selector_from, selector_to, consistency_check) => {
  let timeFromInput = $(selector_from.data('target'));
  let timeToInput = $(selector_to.data('target'));

  selector_to.on('change', (e) => {
    setToHour(timeToInput, selector_to.val());
    setPopover(timeToInput, selector_to.val());
    if (consistency_check) {
      consistencyCheck(selector_from, selector_from.val(), selector_to, selector_to.val());
    }
  });

  selector_from.on('change', (e) => {
    setFromHour(timeFromInput, selector_from.val());
    if (consistency_check) {
      consistencyCheck(selector_from, selector_from.val(), selector_to, selector_to.val());
    }
  });

  timeToInput.on('change', (e) => {
    setPopover(timeToInput, selector_to.val());
  });
};

const init = (selector_from, selector_to, consistency_check) => {
  try {
    setListener(selector_from, selector_to, consistency_check);
  } catch (e) {
    errorManager(e);
  }
};

window.setEndTime = {
  init: init,
};
